import { useTranslation } from 'module/hooks/use-translation';
import {
  CustomLayoutDrawer,
  CustomLayoutDrawerContent,
  DefaultCustomLayoutDrawerProps,
} from 'module/ui/components/atoms/drawer';
import { Button } from '@rocketlane/ui';
import { FC } from 'react';
import { FilterWrapper } from './components';

interface Props {
  title: string | React.ReactNode;
  onDone: () => void;
  visible: boolean;
  onClose: VoidFunction;
  filterComponent: React.ReactNode;
}

export const BaseFilterDrawer: FC<Props> = ({
  title,
  visible,
  onClose,
  onDone,
  filterComponent,
}) => {
  return (
    <CustomLayoutDrawer
      width={800}
      open={visible}
      onClose={onClose}
      {...DefaultCustomLayoutDrawerProps}
    >
      <CustomLayoutDrawerContent>
        <CustomLayoutDrawerContent.Title>
          {title}
        </CustomLayoutDrawerContent.Title>
        <CustomLayoutDrawerContent.Content>
          <FilterWrapper>{visible && filterComponent}</FilterWrapper>
        </CustomLayoutDrawerContent.Content>
        <CustomLayoutDrawerContent.Footer $rightAlignedAction>
          <Button
            variant="secondary"
            onClick={onClose}
            data-cy="filter-drawer.cancel"
          >
            {useTranslation('cancel')}
          </Button>
          <Button
            variant="primary"
            onClick={onDone}
            data-cy="filter-drawer.done"
          >
            {useTranslation('done')}
          </Button>
        </CustomLayoutDrawerContent.Footer>
      </CustomLayoutDrawerContent>
    </CustomLayoutDrawer>
  );
};
